/**
 * Internal element type.
 */
export enum TimelineElementType {
  /**
   * Timeline
   */
  Timeline = 'timeline',
  /**
   * Keyframes
   */
  Keyframe = 'keyframe',
  /**
   * Keyframes connected and presenting one group.
   */
  Group = 'group',
  /**
   * Timeline row.
   */
  Row = 'row',
  None = 'none',
}
